<template>
    <div class="detail_com" :style="{ height: containerHeight + 'px' }">
        <div class="detail_header">
            <div class="back_btn" @click="back">
                <van-icon name="arrow-left" color="#333333" size="20" />
            </div>
            <span class="detail_title">报备详情</span>
        </div>
        <div class="detail_meta">
            <div class="meta_left">
                <div :class="['status_tag', statusInfo.className]">
                    <span class="status_tag_text">{{ statusInfo.label }}</span>
                </div>
                <span class="meta_type">{{ record.type || '报备详情' }}</span>
            </div>
        </div>
        <div class="detail_tip" v-if="!isDone">
            <van-icon name="info-o" color="#E6A23C" size="16" />
            <span class="detail_tip_text">如需补充材料，请在下方回复并上传相关图片</span>
        </div>
        <div class="detail_scroll" :style="{ height: scrollHeight + 'px' }">
            <div class="msg_list">
                <div
                    class="msg_item"
                    v-for="(item, index) in chatList"
                    :key="item.id || index">
                    <div :class="['msg_avatar', item.isDriver ? 'msg_avatar_driver' : 'msg_avatar_admin']">
                        <span class="msg_avatar_text">{{ item.isDriver ? '我' : (item.avatarText || '调') }}</span>
                    </div>
                    <div class="msg_body">
                        <div class="msg_header">
                            <div class="msg_user_row">
                                <span class="msg_name">{{ item.isDriver ? '我' : (item.userName || item.roleName) }}</span>
                                <div
                                    v-if="!item.isDriver"
                                    class="role_tag role_tag_admin">
                                    <span class="role_tag_text">{{ item.roleLabel || '调度' }}</span>
                                </div>
                                <span class="msg_uid" v-if="item.userId">#{{ item.userId }}</span>
                            </div>
                            <span class="msg_time">{{ item.time }}</span>
                        </div>
                        <div class="msg_content_wrap" v-if="item.content || getScalarInfo(item)">
                            <div class="msg_content" v-if="item.content">{{ item.content }}</div>
                            <div class="msg_scalar_row" v-if="getScalarInfo(item)">
                                <span class="msg_scalar_text">{{ getScalarInfo(item).text }}</span>
                                <div
                                    class="msg_agree_btn"
                                    v-if="showAgreeBtn(item)"
                                    @click="handleAgree(item)">
                                    <span class="msg_agree_btn_text">同意</span>
                                </div>
                            </div>
                        </div>
                        <div class="msg_images" v-if="item.images && item.images.length">
                            <img
                                v-for="(img, imgIndex) in item.images"
                                :key="imgIndex"
                                :src="img"
                                class="msg_image"
                                @click="preImg(item.images, imgIndex)">
                        </div>
                    </div>
                </div>
                <div class="msg_empty" v-if="!chatList.length">
                    <span class="msg_empty_text">暂无沟通记录</span>
                </div>
            </div>
        </div>
        <div class="detail_footer detail_result_footer" v-if="isDone">
            <div class="result_section">
                <div class="result_info">
                    <span class="result_title">处理结果</span>
                    <span class="result_status" v-if="statusStampInfo">{{ statusStampInfo.label }}</span>
                    <span class="result_scalar" v-if="resultScalarText">{{ resultScalarText }}</span>
                </div>
                <img
                    v-if="statusStampInfo && stampImg"
                    class="result_stamp_img"
                    :src="stampImg">
            </div>
        </div>
        <div class="detail_footer" v-else>
            <div class="reply_price_section" v-if="isPriceNegotiation">
                <div class="reply_price_label">议价价格（必填）</div>
                <div class="reply_price_input_wrap">
                    <van-field
                        v-model="replyExtraPrice"
                        placeholder="请输入议价价格"
                        type="number"
                        input-align="left" />
                    <span class="reply_price_suffix">元</span>
                </div>
            </div>
            <van-field
                v-model="replyText"
                rows="2"
                autosize
                type="textarea"
                maxlength="500"
                placeholder="请输入回复内容"
                show-word-limit />
            <div class="upload_section">
                <div class="upload_header">
                    <span class="upload_label">上传附件</span>
                    <span class="upload_tips">最多10张</span>
                </div>
                <van-uploader
                    v-model="replyImages"
                    multiple
                    :max-count="maxImageCount"
                    :preview-full-image="true" />
            </div>
            <div class="reply_actions">
                <div class="cancel_btn" @click="openCancelSheet">
                    <span class="cancel_btn_text">取消</span>
                </div>
                <div class="reply_btn" @click="submitReply">
                    <span class="reply_btn_text">回复</span>
                </div>
            </div>
        </div>
        <van-action-sheet
            v-model="cancelSheetShow"
            :actions="cancelReasonActions"
            cancel-text="再想想"
            description="请选择取消理由"
            @select="handleSelectCancelReason" />
    </div>
</template>

<script>
import { ImagePreview, Dialog, Toast } from 'vant';
import { getScalarDisplay, getReportStatusStamp } from '@/utils/reportFile.js';

const CANCEL_REASONS = [
    '申请内容填写错误',
    '重复提交',
    '问题已自行解决',
    '不再需要此报备',
    '信息与实际情况不符'
];

export default {
    name: 'orderReportDetail',
    props: {
        record: {
            type: Object,
            default: () => ({})
        },
        containerHeight: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            maxImageCount: 10,
            replyText: '',
            replyImages: [],
            replyExtraPrice: '',
            cancelSheetShow: false
        };
    },
    computed: {
        cancelReasonActions() {
            return CANCEL_REASONS.map((name) => ({ name }));
        },
        isDone() {
            const record = this.record || {};
            return record.is_done == 1;
        },
        isPriceNegotiation() {
            const record = this.record || {};
            return record.typeValue === 'price_negotiation';
        },
        topSectionHeightPx() {
            let height = 44 + 34;
            if (!this.isDone) {
                height += 34;
            }
            return Math.floor(height);
        },
        footerSectionHeightPx() {
            if (this.isDone) {
                return 90;
            }
            let height = 200;
            if (this.isPriceNegotiation) {
                height += 70;
            }
            if (this.replyImages.length) {
                height += 60;
            }
            return Math.floor(height);
        },
        scrollHeight() {
            const total = this.containerHeight || Math.floor(window.innerHeight * 0.9);
            const height = total - this.topSectionHeightPx - this.footerSectionHeightPx;
            return Math.max(160, Math.floor(height));
        },
        statusStampInfo() {
            const record = this.record || {};
            return getReportStatusStamp(record.status);
        },
        stampImg() {
            const stamp = this.statusStampInfo;
            if (!stamp) {
                return '';
            }
            return stamp.stampImg || '';
        },
        resultScalarText() {
            const record = this.record || {};
            const result = record.result;
            if (!result || result.scalar === undefined || result.scalar === null || result.scalar === '') {
                return '';
            }
            const scalarInfo = getScalarDisplay(record.typeValue, result.scalar);
            if (!scalarInfo) {
                return '';
            }
            const prefix = record.typeValue === 'price_negotiation' ? '最终同意价格：' : '';
            return prefix + scalarInfo.text;
        },
        statusInfo() {
            const record = this.record || {};
            if (record.is_done == 1) {
                return { label: '已处理', className: 'status_done' };
            }
            return { label: '待处理', className: 'status_pending' };
        },
        chatList() {
            const record = this.record || {};
            if (!record.id) {
                return [];
            }
            if (Array.isArray(record.messages) && record.messages.length) {
                return record.messages;
            }
            const list = [{
                role: 'me',
                roleName: '我',
                userName: '我',
                roleLabel: '我',
                userId: '',
                avatarText: '我',
                isDriver: true,
                content: record.remark || '',
                images: record.images || [],
                time: record.time || ''
            }];
            (record.replies || []).forEach((item) => {
                const isDriver = item.isDriver || item.role === 'me' || item.roleName === '我';
                list.push({
                    role: isDriver ? 'me' : 'dispatcher',
                    roleName: isDriver ? '我' : (item.roleName || item.name || '调度员'),
                    userName: isDriver ? '我' : (item.userName || item.roleName || item.name || '调度员'),
                    roleLabel: isDriver ? '我' : (item.roleLabel || '调度'),
                    userId: item.userId || '',
                    avatarText: isDriver ? '我' : (item.avatarText || '调'),
                    isDriver,
                    content: item.content || '',
                    images: item.images || [],
                    time: item.time || ''
                });
            });
            return list;
        }
    },
    methods: {
        getScalarInfo(item) {
            const record = this.record || {};
            const extra = item.extra;
            const scalar = extra && typeof extra === 'object' ? extra.scalar : extra;
            return getScalarDisplay(record.typeValue, scalar);
        },
        showAgreeBtn(item) {
            const scalarInfo = this.getScalarInfo(item);
            if (!scalarInfo || !scalarInfo.showAgree) {
                return false;
            }
            if (item.isDriver) {
                return false;
            }
            const record = this.record || {};
            if (record.is_done == 1 || record.status == 1) {
                return false;
            }
            return true;
        },
        handleAgree(item) {
            const contentId = item.contentId || item.id;
            if (!contentId) {
                return;
            }
            this.$emit('agree', {
                report_id: this.record.id,
                content_id: contentId
            });
        },
        back() {
            this.$emit('back');
        },
        preImg(urls, index) {
            if (!urls || !urls.length) {
                return;
            }
            ImagePreview({
                images: urls,
                startPosition: index
            });
        },
        validateReplyPrice() {
            const val = this.replyExtraPrice.trim();
            if (!val) {
                Toast('请输入议价价格');
                return false;
            }
            const num = Number(val);
            if (isNaN(num) || num <= 0) {
                Toast('请输入有效的议价价格');
                return false;
            }
            return true;
        },
        submitReply() {
            if (this.isPriceNegotiation) {
                if (!this.validateReplyPrice()) {
                    return;
                }
            } else if (!this.replyText.trim() && this.replyImages.length === 0) {
                Toast('请输入回复内容或上传附件');
                return;
            }
            const payload = {
                id: this.record.id,
                content: this.replyText.trim(),
                images: [...this.replyImages]
            };
            if (this.isPriceNegotiation) {
                payload.extra = this.replyExtraPrice.trim();
            }
            this.$emit('reply', payload);
            this.replyText = '';
            this.replyImages = [];
            this.replyExtraPrice = '';
        },
        openCancelSheet() {
            this.cancelSheetShow = true;
        },
        handleSelectCancelReason(item) {
            const reason = item && item.name;
            if (!reason) {
                return;
            }
            this.cancelSheetShow = false;
            Dialog.confirm({
                title: '取消报备',
                message: `确定取消该报备申请？\n取消理由：${reason}`,
                confirmButtonText: '确定取消',
                cancelButtonText: '再想想',
                confirmButtonColor: '#357EFE'
            }).then(() => {
                this.$emit('closeReport', {
                    report_id: this.record.id,
                    remark: reason
                });
            }).catch(() => {});
        }
    }
};
</script>

<style lang="scss" scoped>
.detail_com {
    display: flex;
    flex-direction: column;
    background: #F5F7FA;
    overflow: hidden;
}
.detail_header {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 40px;
    position: relative;
    background: #ffffff;
    border-bottom: 1px solid #EBEEF5;
}
.back_btn {
    position: absolute;
    left: 10px;
    padding: 5px;
}
.detail_title {
    font-size: 16px;
    color: #303133;
    font-weight: bold;
}
.detail_meta {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background: #ffffff;
    border-bottom: 1px solid #EBEEF5;
}
.meta_left {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
}
.status_tag {
    padding: 2px 8px;
    border-radius: 3px;
    margin-right: 8px;
    flex-shrink: 0;
}
.status_done {
    background: #F0F9EB;
}
.status_pending {
    background: #FEF0F0;
}
.status_tag_text {
    font-size: 11px;
}
.status_done .status_tag_text {
    color: #67C23A;
}
.status_pending .status_tag_text {
    color: #F56C6C;
}
.meta_type {
    font-size: 14px;
    color: #303133;
    font-weight: 500;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.detail_tip {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding: 6px 12px;
    background: #FDF6EC;
    border-bottom: 1px solid #FAECD8;
}
.detail_tip_text {
    font-size: 12px;
    color: #E6A23C;
    margin-left: 5px;
    flex: 1;
    line-height: 18px;
}
.detail_scroll {
    width: 100%;
    background: #ffffff;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}
.msg_list {
    padding: 0 12px;
    box-sizing: border-box;
}
.msg_item {
    display: flex;
    padding: 14px 0;
    border-bottom: 1px solid #EBEEF5;
}
.msg_avatar {
    width: 36px;
    height: 36px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 10px;
}
.msg_avatar_driver {
    background: #FF9800;
}
.msg_avatar_admin {
    background: #409EFF;
}
.msg_avatar_text {
    font-size: 16px;
    color: #ffffff;
    font-weight: bold;
}
.msg_body {
    flex: 1;
    min-width: 0;
    overflow: hidden;
}
.msg_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
}
.msg_user_row {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    margin-right: 8px;
}
.msg_name {
    font-size: 14px;
    color: #303133;
    font-weight: bold;
    margin-right: 6px;
}
.role_tag {
    padding: 1px 6px;
    border-radius: 2px;
    margin-right: 6px;
}
.role_tag_admin {
    background: #ECF5FF;
}
.role_tag_text {
    font-size: 10px;
}
.role_tag_admin .role_tag_text {
    color: #409EFF;
}
.msg_uid {
    font-size: 11px;
    color: #909399;
}
.msg_time {
    font-size: 11px;
    color: #909399;
    flex-shrink: 0;
}
.msg_content {
    font-size: 14px;
    color: #606266;
    line-height: 21px;
    word-wrap: break-word;
    word-break: break-all;
    white-space: pre-wrap;
}
.msg_scalar_row {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 4px;
}
.msg_scalar_text {
    font-size: 13px;
    color: #E6A23C;
    font-weight: 500;
}
.msg_agree_btn {
    margin-left: 8px;
    padding: 2px 10px;
    border-radius: 3px;
    background: linear-gradient(90deg, #357EFE, #5B9BFF);
}
.msg_agree_btn_text {
    font-size: 12px;
    color: #ffffff;
}
.msg_images {
    display: flex;
    flex-wrap: wrap;
    margin-top: 8px;
}
.msg_image {
    width: 70px;
    height: 70px;
    border-radius: 4px;
    margin-right: 6px;
    margin-bottom: 6px;
    border: 1px solid #EBEEF5;
    object-fit: cover;
}
.msg_empty {
    padding: 60px 0;
    display: flex;
    justify-content: center;
}
.msg_empty_text {
    font-size: 14px;
    color: #909399;
}
.detail_footer {
    flex-shrink: 0;
    padding: 8px 12px;
    border-top: 1px solid #EBEEF5;
    background: #ffffff;
    box-sizing: border-box;
}
.reply_price_section {
    margin-bottom: 6px;
}
.reply_price_label {
    font-size: 13px;
    color: #303133;
    margin-bottom: 5px;
}
.reply_price_input_wrap {
    display: flex;
    align-items: center;
    background: #f7f8fa;
    border-radius: 4px;
    overflow: hidden;
}
.reply_price_input_wrap ::v-deep .van-field {
    flex: 1;
    background: transparent;
}
.reply_price_suffix {
    margin-right: 12px;
    font-size: 14px;
    color: #303133;
    flex-shrink: 0;
}
.upload_section {
    margin-top: 6px;
}
.upload_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
}
.upload_label {
    font-size: 13px;
    color: #303133;
}
.upload_tips {
    font-size: 12px;
    color: #909399;
}
.reply_actions {
    margin-top: 6px;
    display: flex;
    align-items: center;
}
.cancel_btn {
    flex: 1;
    height: 36px;
    margin-right: 10px;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    background: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
}
.cancel_btn_text {
    font-size: 15px;
    color: #606266;
}
.reply_btn {
    flex: 1;
    height: 36px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(90deg, #357EFE, #5B9BFF);
}
.reply_btn_text {
    font-size: 15px;
    color: #ffffff;
}
.detail_result_footer {
    position: relative;
    overflow: hidden;
}
.result_section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 60px;
    padding: 4px 0;
}
.result_info {
    flex: 1;
    min-width: 0;
    padding-right: 12px;
}
.result_title {
    display: block;
    font-size: 13px;
    color: #909399;
    margin-bottom: 6px;
}
.result_status {
    display: block;
    font-size: 16px;
    color: #303133;
    font-weight: bold;
    margin-bottom: 4px;
}
.result_scalar {
    display: block;
    font-size: 14px;
    color: #E6A23C;
    font-weight: 500;
}
.result_stamp_img {
    width: 60px;
    height: 60px;
    flex-shrink: 0;
    opacity: 0.92;
}
</style>
